import { useContext, useEffect, useState } from 'react';
import { Tooltip } from '@fluentui/react-components';

import DocumentContext from '../../../contexts/DocumentContext.context';

/** A paragraph field's description on hover, in the app's tooltip; a card shows its own under its label. */
const FieldDescriptionTooltip = () => {
  const { editor } = useContext(DocumentContext);
  // The field under the pointer whose node view carries a description; saved html elsewhere has the attribute too.
  const [field, setField] = useState<HTMLElement>();

  useEffect(() => {
    const onOver = (event: MouseEvent) => {
      const hovered = event.target instanceof Element ? event.target.closest<HTMLElement>('[data-description]') : null;
      // A view not mounted yet, or already destroyed, has no dom to ask.
      setField(hovered && !editor.isDestroyed && editor.view.dom.contains(hovered) ? hovered : undefined);
    };
    document.addEventListener('mouseover', onOver);
    return () => document.removeEventListener('mouseover', onOver);
  }, []);

  return (
    <Tooltip
      content={field?.dataset.description ?? ''}
      relationship="description"
      visible={!!field}
      positioning={{ target: field }}
      withArrow
    >
      {/* Shown at the hovered field, the tooltip still needs a trigger of its own. */}
      <span className="hidden" />
    </Tooltip>
  );
};

export default FieldDescriptionTooltip;
